<div class="row align-items-end">
    <div class="col my-auto" [class.flex-grow-0]="!esTelefono">
        <label>Limites</label>
    </div>
    <div class="col-3 col-md-2 flex-grow-0">
        <div class="mb-3">
            <label class="form-label">Min</label>
            <input type="number" class="form-control" [(ngModel)]="pregunta.MinimoItemsSeleccionados"
                [disabled]="accesoPublico">
        </div>
    </div>
    <div class="col-3 col-md-2 flex-grow-0">
        <div class="mb-3">
            <label class="form-label">Max</label>
            <input type="number" class="form-control" [(ngModel)]="pregunta.MaximoItemsSeleccionados"
                   [disabled]="accesoPublico">
        </div>
    </div>
</div>
<app-item-pregunta-seleccion-imagen *ngFor="let item of items" [item]="item" [color]="colores[obtenerId(pregunta.Tipo)]"
    [pregunta]="pregunta" (borrarItem)="borrarCmd.ejecutar(item)" (abrirAcciones)="abrirAccionesCmd.ejecutar(item)"
    [accesoPublico]="accesoPublico">
</app-item-pregunta-seleccion-imagen>
<div class="row" *ngIf="!accesoPublico">
    <div class="col flex-grow-0 h3 mb-0 pe-0">+</div>
    <div class="col mb-3">
        <input type="text" placeholder="Agregue una respuesta..." class="form-control no-borders"
            [(ngModel)]="textoItem" (keyup.enter)="agregarCmd.ejecutar()" [disabled]="!agregarCmd.puedeEjecutarse" />
    </div>
</div>
